import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomPrintIcon from '../../../../components/icons/CustomPrintIcon';

const propTypes = {
  className: PropTypes.string,
  badgeStyle: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'success-vibrant',
    'info',
    'warning',
    'danger',
    'glass',
    'link',
    'reset',
    'yellow',
    'white',
    'gray',
  ]),
};

const CustomPrintBadge = ({ className, badgeStyle = 'primary' }) => {
  const classes = classNames({
    'custom-print-badge': true,
    [`custom-print-badge-${badgeStyle}`]: true,
    [className]: !!className,
  });

  return (
    <span className={classes}>
      <CustomPrintIcon />
    </span>
  );
};

CustomPrintBadge.propTypes = propTypes;

export default CustomPrintBadge;
